import { Pipe, PipeTransform } from '@angular/core';
import { AlertErrorCode } from '@monitor/alerting/data/alerting.models';

@Pipe({
  name: 'alertErrorCodeTranslationKey',
  standalone: true,
})
export class AlertErrorCodeTranslationKeyPipe implements PipeTransform {
  transform(errorCode: AlertErrorCode): string {
    switch (errorCode) {
      case AlertErrorCode.CHARGING_FAILED:
      case AlertErrorCode.SESSION_START_ABORTED:
      case AlertErrorCode.START_REQUEST_FAILED:
      case AlertErrorCode.START_ACTIVATION_FAILED:
      case AlertErrorCode.STOP_ACTIVATION_FAILED:
      case AlertErrorCode.STOP_REQUEST_FAILED:
        return `UNLOCK_MONITOR.${errorCode}`;
      case AlertErrorCode.ABORTED:
        return 'CHARGE_RECORDS.CDR_PROCESSING_STATUS_ABORTED';
      case AlertErrorCode.SDR_INVALID:
      case AlertErrorCode.PERISHED:
        return `UNLOCK_MONITOR.ENDED_${errorCode}`;
      default:
        return `CHARGE_RECORDS.BDR_REASON_${errorCode}`;
    }
  }
}
